import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-bcf4022e")

_pushScopeId("data-v-bcf4022e")
const _hoisted_1 = { class: "transition_container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_lottie = _resolveComponent("lottie")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_lottie, {
      options: _ctx.defaultOptions,
      onAnimCreated: _ctx.handleAnimation
    }, null, 8, ["options", "onAnimCreated"])
  ]))
})